import { AppState } from '../../../page-screen/page-screen.reducer';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { RootAppState } from '../../../app.reducer';
import { Genre } from '../../../domain/genre';
import { selectGenres } from '../../../app.selectors';
import { selectAlreadyUsedGenres } from '../../../page-screen/page-screen.selectors';

@Injectable()
export class GenreSelectorService {
  public genres$: Observable<Genre[]> = this.store.select(selectGenres).pipe(
    map((genres) =>
      genres && genres.length
        ? genres
            .map((genre) => ({
              id: genre.id,
              title: genre.title,
              guid: genre.guid,
            }))
            .sort((a, b) => a.title.localeCompare(b.title))
        : []
    )
  );

  public getFilteredGenres$(genreOrId: Genre | string): Observable<Genre[]> {
    return this.genres$.pipe(
      withLatestFrom(this.pageStore.select(selectAlreadyUsedGenres)),
      map(([genres, alreadyUsedGenres]) => {
        const usedGenreIds = alreadyUsedGenres.map((it) => it.id);
        return (
          genres?.filter(
            (genre) =>
              !usedGenreIds.includes(genre.id) || (typeof genreOrId === 'string' ? genreOrId === genre.id : genreOrId?.id === genre.id)
          ) ?? []
        );
      })
    );
  }

  constructor(private readonly store: Store<RootAppState>, private readonly pageStore: Store<AppState>) {}
}
